var countryMaps = {
        'GB': {
        fullUrl: 'www.litelok.com',
        storeName: 'UK',
        internalCode: 'en-gb'
    }, // UK
    'AU': {
        fullUrl: 'www.litelok.com/en-au',
        storeName: 'Australia',
        internalCode: 'en-au'
    }, // Australia
    'CA': {
        fullUrl: 'us.litelok.com/en-ca',
        storeName: 'Canada',
        internalCode: 'en-ca'
    }, // Canada
    'NZ': {
        fullUrl: 'www.litelok.com/en-nz',
        storeName: 'New Zealand',
        internalCode: 'en-nz'
    }, // New Zealand
    'US': {
        fullUrl: 'us.litelok.com',
        storeName: 'United States',
        internalCode: 'en-us'
    }, // United States
    'IE': {
        fullUrl: 'eu.litelok.com',
        storeName: 'Ireland',
        internalCode: 'en-ie'
    }, // Ireland
    'FR': {
        fullUrl: 'fr.litelok.com/',
        storeName: 'France',
        internalCode: 'fr-fr'
    }, // France
    'DE': {
        fullUrl: 'de.litelok.com/',
        storeName: 'Germany',
        internalCode: 'de-de'
    }, // Germany
    'NL': {
        fullUrl: 'nl.litelok.com/',
        storeName: 'Netherlands',
        internalCode: 'nl-nl'
    }, // Netherlands
    'EU': {
        fullUrl: 'eu.litelok.com',
        storeName: 'European Union',
        internalCode: 'eu-eu'
    }, // Europe
    'ROW': {
        fullUrl: 'us.litelok.com',
        storeName: 'International',
        internalCode: 'row'
    } // Rest of world
}

var currentUrl = window.location.href
var storeToBeOn = '';
var storeToBeOnName = '';


var currentStoreCode = function () {
    var pathParts = window.location.pathname.split('/').filter(el => el);
    var intCode = '';
    if (pathParts.length > 0 && pathParts[0].includes('-')) {
        intCode = pathParts[0]
    } else {
        if (currentUrl.search('/www.') != -1) {
            intCode = 'en-gb'
        } else if (currentUrl.search('/eu.') != -1) {
            intCode = 'eu-eu'
        } else if (currentUrl.search('/fr.') != -1) {
            intCode = 'fr-fr'
        } else if (currentUrl.search('/de.') != -1) {
            intCode = 'de-de'
        } else if (currentUrl.search('/nl.') != -1) {
            intCode = 'nl-nl'
        } else {
            intCode = 'en-us'
        }
    }
    return intCode;
}

console.log(currentStoreCode());
var curStoreKey = getKeyByValue(countryMaps, currentStoreCode());
var currentStore = countryMaps[curStoreKey];

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


function htmlModalPopup(curCountry, storeToBeOn, storeToBeOnName, currentCountryName) {
    var flagCode = 'flag-' + countryMaps[curCountry].internalCode;
    var flag = document.getElementById(flagCode).innerHTML;
    return '<div id="countryPickerModal" class="countryPickerModal">' +
        '<a onclick="closeCountryPickerModal(event)" class="modal-close" href="#">'+ document.getElementById('close-icon').innerHTML+'</a>' +
        '<h3>WELCOME TO LITELOK</h3><p>It looks like you\'re visiting our website from ' + currentCountryName + '. Would you like to shop your local website?</p>' +
        '<div class="flagWrapper"><a class="modal-btn" href="https://' + storeToBeOn + '">' + flag + ' YES, TAKE ME THERE</a><br>' +
        '<a style="opacity: 0.7" onclick="closeCountryPickerModal(event)" href="#">STAY HERE, THANKS</a></div>' +
        '</div><div id="countryPickerModalBg" class="countryPickerModalBg"></div>'
}

function htmlCountrySelectModalPopup() {
    return '<div id="countryPickerModal" class="countryPickerModal hidden">' +
        '<a onclick="closeCountryPickerModal(event)" class="modal-close" href="#">'+ document.getElementById('close-icon').innerHTML+'</a>' +
        '<h3>CHOOSE YOUR LOCATION</h3>' +
        // '<a onclick="closeCountryPickerModal(event)" href="#">' + countryMaps[curStoreKey].flag + currentStore.storeName + '</a>' +
        '<div class="country-selector-and-btn"><select id="countrySelection">' +
        generateSelectOfCountries() +
        '</select> <button class="modal-btn" style="button" onclick="changeLocationBasedOnSelection()">Confirm</button></div></div>' +
        '</div><div id="countryPickerModalBg" class="countryPickerModalBg hidden"></div>'
}

function generateSelectOfCountries() {
    var output = '';
      for (var key in countryMaps) {
        if (countryMaps.hasOwnProperty(key) && countryMaps[key].internalCode == currentStoreCode()) {
            output += '<option value="' + countryMaps[key].fullUrl + '">' + countryMaps[key].storeName + '</option>';
        }
    }
    for (var key in countryMaps) {
        if (countryMaps.hasOwnProperty(key) && countryMaps[key].internalCode != currentStoreCode()) {
            output += '<option value="' + countryMaps[key].fullUrl + '">' + countryMaps[key].storeName + '</option>';
        }
    }
    return output;
}

//https://countryflagsapi.com/

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key].internalCode === value);
}

function closeCountryPickerModal(e) {
    e.preventDefault();
    // document.getElementById('countryPickerModal').classList.add('hidden');
    // document.getElementById('countryPickerModalBg').classList.add('hidden');
    document.getElementById('countryPickerModal').remove()
    document.getElementById('countryPickerModalBg').remove();
    document.documentElement.classList.remove('lock');

}

function changeLocationBasedOnSelection() {
    var countrySelection = document.getElementById('countrySelection');
    window.location.href = 'https://' + countrySelection.value;
}


var countryRedirect = (function () {
    var onSuccess = function (geoipResponse) {
        console.log(geoipResponse);
        var currentCountry = geoipResponse.country.iso_code;
        var currentCountryName = geoipResponse.country.names.en;
        var currentContinent = geoipResponse.continent.code;
        if (currentCountry in countryMaps) {
            console.log(countryMaps[currentCountry]);
            storeToBeOn = countryMaps[currentCountry].fullUrl;
            storeToBeOnName = countryMaps[currentCountry].storeName;
        } else {
            //If we don't have it in the country maps, but they are in the EU - send them there
            if (currentContinent === 'EU') {
                currentCountry = 'EU';
                storeToBeOn = countryMaps['EU'].fullUrl
                storeToBeOnName = countryMaps['EU'].storeName;

            } else {
                //If they're not in any of the countries OR in Europe, send them to the ROW store
                storeToBeOn = countryMaps['ROW'].fullUrl
                storeToBeOnName = countryMaps['ROW'].storeName;
            }
        }

        //If the storeToBeOn can't be found within the currentUrl then we're on the wrong store and we should trigger the modal
        if (currentUrl.search(storeToBeOn) === -1) {
            console.log('[GEOIP] on the wrong store')
            if (currentContinent === 'EU') {
                document.body.insertAdjacentHTML('beforeend', htmlModalPopup(currentCountry, storeToBeOn, storeToBeOnName, currentCountryName))
            } else {
                /**
                 * This works correctly, but for the time being has been disabled while in development
                 */
                window.location.href = 'https://' + storeToBeOn;
            }
        } else {
            console.log('[GEOIP] on the right store')
        }


    };

    // If we get an error, we will display an error message
    var onError = function (error) {
        console.error(error);
    };

    return function () {
        if (typeof geoip2 !== 'undefined') {
            geoip2.country(onSuccess, onError);
        } else {
            console.error('a browser that blocks GeoIP2 requests');
        }
    };
}())


var ipLookupInit = function () {

    if (getCookie('glueIpLookup', 'true')) {
        console.log('[GEOIP] Country set, exit')
        return;
    }

  var urlSearchParams = new URLSearchParams(window.location.search);
  var urlParams = Object.fromEntries(urlSearchParams.entries());
  console.log('urlParams', urlParams);
    if (urlParams.hasOwnProperty('country-selected') === true) {
        console.log('[GEOIP] Country set via query string, exit');
        setCookie('glueIpLookup', 'true', 30);
        return;
      console.log('this should not fire');
    }

    var domain = window.location.hostname.split('.');

    if (domain[1] === 'shopifypreview') {
        console.log('[GEOIP] on shopify preview, cancel redirect')
        // return;
    }

    var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
    var re = new RegExp(botPattern, 'i');
    var userAgent = navigator.userAgent;
    if (re.test(userAgent)) {
        console.log('the user agent is a crawler!');
        return;
    }

    countryRedirect();

    setCookie('glueIpLookup', 'true', 30);
}

document.addEventListener("DOMContentLoaded", function (event) {
    ipLookupInit();

});


document.addEventListener("DOMContentLoaded", function (event) {
    var flagCode = 'flag-' + currentStore.internalCode;
    var flag = document.getElementById(flagCode).innerHTML;
    var countrySelect2 = document.getElementById('countrySelectorv2');
  console.log('this bit?');
    // countrySelect2.innerHTML = flag + '<p style="margin-bottom: 0; margin-left: 10px;">' + currentStore.storeName + '</p>';

    // countrySelect2.addEventListener('onclick', function () {
    //     console.log('[GEOIP] clicked the picker');
    //     document.getElementById('countryPickerModal').classList.remove('hidden')
    //     document.getElementById('countryPickerModalBg').classList.remove('hidden')
    // })


  var countrySelect3 = document.getElementsByClassName('countrySelectorv3');

  for(var i = 0; i < countrySelect3.length; i++){
        countrySelect3[i].innerHTML = flag + '<p data-test style="margin-bottom: 0; margin-left: 10px;">' + currentStore.storeName + '</p>';

    countrySelect3[i].addEventListener('onclick', function () {
        console.log('[GEOIP] clicked the picker');
        document.getElementById('countryPickerModal').classList.remove('hidden')
        document.getElementById('countryPickerModalBg').classList.remove('hidden')
      document.getElementById('header-sidebar-menu').removeAttribute('open')
    })
  }


    console.log(countrySelect2.click);

});

var openCountryPicker = function () {
    document.body.insertAdjacentHTML('beforeend', htmlCountrySelectModalPopup());
  console.log('[GEOIP] clicked the picker');
    document.getElementById('countryPickerModal').classList.remove('hidden')
    document.getElementById('countryPickerModalBg').classList.remove('hidden')
        document.getElementById('header-sidebar-menu').removeAttribute('open')
}


//Styles

var style = document.createElement('style');
style.innerHTML = `
  .countryPickerModal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  background: white;
  text-align: center;
  z-index: 9999999999;
  padding: 28px;
  border-radius: 8px;
  }
  
  .countryPickerModal.hidden{
  display: none!important;
  }

  .countryPickerModal h3{
    font-size: 30px;
    font-weight: 700;
  }
  
.countryPickerModal select{
  border: 1px solid;
    border-color: #dadada;
    max-width: 100%;
    padding: 8px 10px;
    border-radius: 0;
  }
  .countryPickerModal .flagWrapper{
      display: flex;
      align-items: center;
      flex-direction: column;
  }
  
  .countryPickerModal a:not(.modal-close){
      display: flex;
      align-items: center;
      justify-content: center;
  }

  .modal-btn{
    background: black;
    border-radius: 30px;
    padding: 10px 40px;
    color: white;
  }

  .modal-btn:hover{
    color: white;
    
  }
  
  .countryPickerModal a.modal-close svg{
    margin-right: 20px;
    width: 14px !important;
    height: auto;
  }

    .countryPickerModal a.modal-btn svg{
    margin-right: 20px;
    width: 24px !important;
    height: auto;
  }
  
  .countryPickerModal .modal-close{
    position: absolute;
    right: 0px;
    top: 0px;
    cursor: pointer;
    padding: 15px;
    opacity: 0.8;
    width: auto;

  }
  
  .countryPickerModal .modal-close:hover{
    // background: rgba(0,0,0,0.3)
  }
  
  .countryPickerModalBg{
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0,0,0,0.8);
      z-index: 999999999;
  }
  
  .countryPickerModalBg.hidden{
  display: none!important;
  }
   
  #countrySelectorv2 svg{
  width: 24px;
  height: auto;
  max-height: 30px;
  }
  
  .country-selector-and-btn{
    display: flex;
    flex-direction: column;
    width: 70%;
    margin: auto;
  }
  
  .country-selector-and-btn select{
  margin-bottom: 15px;
  }
  
  @media(max-width: 768px){
    .countryPickerModal {
        width: 80%;
    }
    
    .countryPickerModal .flagWrapper{
        flex-direction: column;
        align-items: flex-start;
    }
    
    .countryPickerModal a{
        width: 100%;
        justify-content: flex-start;
    }

  }
  `;
document.head.appendChild(style);